export default __webpack_public_path__ + "static/media/indogo-screenshot-05.c6f94887.png";